// extracted by mini-css-extract-plugin
export var phone = "_55-0";